import { ArrowRight } from "lucide-react";
import { Reveal, SectionTag, scrollToId } from "./Reveal";

const PROBLEMS = [
  { title: "Price Uncertainty", text: "Know whether the price you're receiving is competitive before you commit." },
  { title: "Supplier Availability", text: "Know who actually has supply available — not just who answers the phone." },
  { title: "Supplier Dependency", text: "Your existing supplier doesn't have to be your only option." },
  { title: "Emergency Procurement", text: "Backup supply options when your normal supplier cannot fulfill." },
  { title: "Procurement Administration", text: "Stop spending hours calling, emailing and chasing multiple suppliers." },
  { title: "Market Visibility", text: "Better information before committing significant amounts of money." },
];

export default function WhyAddAjemi() {
  return (
    <section id="why-add-ajemi" data-testid="why-add-ajemi-section" className="relative py-24 md:py-32 border-b border-white/5">
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <Reveal>
          <SectionTag label="Why Add Ajemi" />
          <h2 className="font-outfit text-3xl md:text-5xl font-extralight tracking-tight text-white max-w-3xl">
            Keep your existing suppliers. <span className="text-gold">Add Ajemi.</span>
          </h2>
          <p className="mt-6 text-white/60 text-base md:text-lg leading-relaxed max-w-2xl">
            You don&rsquo;t need to replace your procurement department. You don&rsquo;t need to
            abandon your existing supplier relationships. Ajemi gives your team additional
            market intelligence and sourcing capability — your procurement team stays in
            control, and Ajemi does the market work.
          </p>
        </Reveal>

        <div className="mt-14 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {PROBLEMS.map((p, i) => (
            <Reveal key={p.title} delay={0.05 * i}>
              <div
                data-testid={`problem-card-${p.title.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}
                className="group h-full glass-panel rounded-2xl p-7 hover:border-gold/30 transition-all duration-500 hover:-translate-y-1"
              >
                <span className="font-outfit text-xs text-gold/60">{String(i + 1).padStart(2, "0")}</span>
                <h3 className="font-outfit text-xl font-light text-white mt-3">{p.title}</h3>
                <p className="text-sm text-white/50 mt-2 leading-relaxed">{p.text}</p>
              </div>
            </Reveal>
          ))}
        </div>

        <Reveal delay={0.2}>
          <button
            data-testid="why-add-ajemi-cta"
            onClick={() => scrollToId("market-check")}
            className="group mt-12 inline-flex items-center gap-2 text-gold font-outfit tracking-wide hover:text-goldbright transition-colors"
          >
            Let Ajemi test the market
            <ArrowRight className="w-4 h-4 group-hover:translate-x-1 transition-transform" />
          </button>
        </Reveal>
      </div>
    </section>
  );
}
